export default {
	
	methods: {
		
		jumpToTopOrderType(id){

			let offsetTop = document.body.querySelectorAll("#"+id)[0].offsetTop
			document.documentElement.scrollTop = offsetTop
			
		}
		
		
	}
	
	
	}